// removed by extract-text-webpack-plugin
module.exports = {"wasabi-tab":"wasabi-tab","default":"default","active":"active","green":"green","wasabi-tabs":"wasabi-tabs","section":"section"};


//////////////////
// WEBPACK FOOTER
// ./~/wasabiD/sass/Layout/Tabs.scss
// module id = 263
// module chunks = 0